import dayjs from '@/utils/dayjs';

export default function formatDate(value: string | Date) {
  if (
    value === undefined ||
    value === null ||
    value === ''
  ) return value;

  return dayjs.strict(value).format('YYYY-MM-DD');
}
